import { pluralize } from '@cian/newbuilding-utils';
import { pathOr } from 'ramda';

import { IBuilderStats } from '../../../types/newbuilding/builder';

export function getStatsString(status: 'done' | 'inProgress', stats: IBuilderStats) {
  const housesCount = pathOr(null, [status, 'housesCount'], stats);
  const newbuildingText = pathOr(null, [status, 'newbuildingText'], stats);

  if (!housesCount || !newbuildingText) {
    return null;
  }

  return `${pluralize(housesCount, ['дом', 'дома', 'домов'])} ${newbuildingText}`;
}

export const getDoneStatsString = getStatsString.bind(null, 'done');
export const getInPeogressStatsString = getStatsString.bind(null, 'inProgress');
